import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { HomepageConfigResponse } from '@/pages/building-dashboard/home-screen/home-screen.types'

type GetHomepageConfigRequest = {
  buildingId: number | undefined
}

export const getHomepageConfigQueryKey = (data: GetHomepageConfigRequest) => [
  'useGetHomepageConfig',
  data,
]

const getHomepageConfig = async (data: GetHomepageConfigRequest) => {
  // Without this, the backend silently strips the newer shortcut types (parking/visitors/
  // essentials) from the response for clients that predate them - this page supports them.
  const response = await authAPI.get<HomepageConfigResponse>('/homepage', {
    params: { buildingId: data.buildingId, newShortcutsSupported: true },
  })
  return response.data
}

export const useGetHomepageConfig = (data: GetHomepageConfigRequest) =>
  useQuery({
    enabled: !!data.buildingId,
    queryFn: () => getHomepageConfig(data),
    queryKey: getHomepageConfigQueryKey(data),
  })
